export enum MaintenanceWindowScope {
  Source = 'Source',
  Integration = 'Integration',
  VerifiableAccount = 'VerifiableAccount',
  Organization = 'Organization',
  Segment = 'Segment',
}
